import type { UserInfo } from "@phurshell/psiapp-frontend-core/domain";
import { defineStore } from "pinia";

export const useUserInfoStore = defineStore("userInfo", {
  state: (): { user_info: UserInfo | null } => ({ user_info: null }),
  actions: {
    save(params: UserInfo) {
      this.user_info = params;
    },
    update(params: Partial<UserInfo>) {
      if (this.user_info) {
        this.user_info = { ...this.user_info, ...params };
      }
    },
    destroy() {
      this.user_info = null;
    },
  },
});
